<template>
  <v-dialog v-model="show" persistent max-width="380" :scrollable="false">
    <v-card :loading="isLoading">
      <v-card-title style="word-break: normal" class="cardTitle">
        {{ title }}
      </v-card-title>
      <v-card-text>
        <ValidationObserver ref="observer">
          <v-form>
            <div>
              <p class="text-left statement">Código de ticket</p>
              <p class="text-center response">
                {{ payload ? payload.attentionTicketCode : '' }}
              </p>
            </div>
            <div>
              <p class="text-left statement">Nombres y apellidos</p>
              <p class="text-center response">
                {{ payload ? payload.customerName : '' }}
              </p>
            </div>
            <div>
              <p class="text-left statement">Plataforma de asignación</p>
              <p class="text-center response">
                {{ payload ? payload.platformName : '' }}
              </p>
            </div>
            <div>
              <p class="text-left statement">Motivo</p>
              <p class="text-center response">
                {{ payload ? payload.reasonName : '' }}
              </p>
            </div>
            <div>
              <p class="text-left statement">Tiempo de atención</p>
              <p class="text-center response">
                <ElapsedTimer :fechaCreacion="dateNow" />
              </p>
            </div>
          </v-form>
        </ValidationObserver>
      </v-card-text>

      <v-card-actions class="cardActionsCustom">
        <v-spacer></v-spacer>
        <v-btn
          :loading="isLoading && loadingPausar"
          color="red"
          text
          @click="handlePausar"
        >
          Pausar
        </v-btn>
        <v-btn
          :loading="isLoading && loadingOk"
          color="primary"
          text
          @click="ok"
          >Finalizar y continuar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ElapsedTimer from '../../common/elapsedTimer/ElapsedTimer';
import { required } from 'vee-validate/dist/rules';
import { extend, ValidationObserver, setInteractionMode } from 'vee-validate';
setInteractionMode('eager');

extend('required', {
  ...required,
  message: 'El campo {_field_} es obligatorio',
});
export default {
  components: {
    ElapsedTimer,
    ValidationObserver,
  },
  name: 'CustomerInformation',
  props: {
    title: { type: String, default: '' },
    isLoading: { type: Boolean, default: false },
  },
  data: () => ({
    show: false,
    payload: {
      queues: [],
    },
    form: {
      typificationCode: null,
      comments: null,
    },
    loadingOk: false,
    loadingPausar: false,
    dateNow: new Date(),
  }),
  watch: {
    isLoading: function (newVal) {
      if (newVal === false) {
        this.loadingOk = newVal;
        this.loadingPausar = newVal;
      }
    },
  },
  methods: {
    open(data) {
      this.show = true;
      this.payload = data;
      this.dateNow = new Date();
    },
    close() {
      this.show = false;
      this.form.typificationCode = null;
      this.form.comments = null;
      this.$refs.observer.reset();
    },
    async ok() {
      this.loadingOk = true;
      const isValidateForm = await this.$refs.observer.validate();
      if (isValidateForm) {
        this.$emit('ok', {
          ...this.payload,
          attentionDetail: { ...this.form },
          attentionTicketStatus: 3,
        });
      }
    },
    handlePausar() {
      this.loadingPausar = true;
      this.$emit('pausar', { ...this.payload, attentionTicketStatus: 2 });
    },
  },
};
</script>

<style scoped>
.cardTitle {
  background-color: #1098f7;
  color: white;
  position: sticky;
  top: 0;
}
p {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.statement {
  color: #949294;
  font-size: 14px;
}
.response {
  color: #1098f7;
  font-size: 18px;
}
.cardActionsCustom {
  border-top: 0.5px solid rgb(203, 203, 203);
  position: sticky;
  bottom: 0;
  background-color: white;
  z-index: 100;
}
</style>
